import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useAuthStore } from '@/store/auth.store';

declare global {
  function getVimeoID(url: string): string | false;
  function getYoutubeID(url: string): string | false;
  function isActive(value: unknown): boolean;
  function logout(payload?: unknown): void;
  function delayLoaded(callback: () => void): void;
  function displayDate(date: string | Date | null | undefined): string;
  function displayTime(date: string | Date | null | undefined): string;
  function displayDateTime(date: string | Date | null | undefined): string;
  function formatDateTime(date: string | Date | null | undefined): string;
  function formatTemplate(template: string, params?: Record<string, unknown>): string;
}

globalThis.getVimeoID = (url: string): string | false => {
  const regExp = /^(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*$/;
  const match = url.match(regExp);
  return match && match[5]?.length >= 6 ? match[5] : false;
};

globalThis.getYoutubeID = (url: string): string | false => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(live\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[8]?.length === 11 ? match[8] : false;
};

globalThis.isActive = (value: unknown): boolean =>
  value === 'on' || value === true;

globalThis.logout = (payload?: unknown): void => {
  // Uses Pinia auth store (legacy logoutRequest merged)
  const authStore = useAuthStore()
  authStore.logoutRequest(payload as { feedback?: unknown } | undefined)
};

globalThis.delayLoaded = (callback: () => void): void => {
  setTimeout(callback, 1000);
};

function parseDate(date: string | Date | null | undefined): Date | null {
  if (!date) return null;
  return typeof date === 'string' ? parseISO(date) : date;
}

globalThis.displayDate = (date): string => {
  const d = parseDate(date);
  return d ? format(d, 'P', { locale: ptBR }) : '';
};

globalThis.displayTime = (date): string => {
  const d = parseDate(date);
  return d ? format(d, 'p', { locale: ptBR }) : '';
};

globalThis.displayDateTime = (date): string => {
  const d = parseDate(date);
  return d ? format(d, 'Pp', { locale: ptBR }) : '';
};

globalThis.formatDateTime = (date): string => {
  const d = parseDate(date);
  return d ? format(d, 'dd/MM/yyyy HH:mm', { locale: ptBR }) : '';
};

globalThis.formatTemplate = (template: string, params: Record<string, unknown> = {}): string =>
  template.replace(/{(\w+)}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match
  );
